if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        // In the back-in-stock "notify" state the cart button is type="button" (see buy-buttons.liquid).
        this.submitButton = this.querySelector('[type="submit"], .js-bis-trigger');
        this.submitButtonText = this.submitButton.querySelector('span');        
        this.enable_multi_variants_add_to_cart = this.form.getAttribute('enable_multi_variants_add_to_cart') === 'true';
        
        

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const hasMultiVariants = this.enable_multi_variants_add_to_cart;

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        // A sold-out variant must never be submitted (e.g. implicit submit via Enter while the button says "Notify me").
        if (this.submitButton.dataset.buttonState === 'notify') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        document.body.classList.remove('js-overflow-hidden');

        var allow_cart_drawer = false;
        if(this.hasAttribute('data-open-cart-drawer')){
          allow_cart_drawer = true;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if(hasMultiVariants){
          const itemsArray = [];
          const closestPoductInfo = this.closest('product-info');
          itemsArray.push({
            id: this.form.querySelector('input[name="id"]').value,
            quantity: 1,
          });
          if(closestPoductInfo){    
            const MainProductContainer = closestPoductInfo.querySelector('.pro_buy_btn');
            if(MainProductContainer){
              const MainProductForm = MainProductContainer.querySelector('input[name="id"]');
              if(MainProductForm){
                const mainProductVariantId = MainProductForm.value;
                itemsArray.push({
                  id: mainProductVariantId,
                  quantity: 1,
                });
            }
          }
        }
        if(itemsArray.length <= 0) return;
        const headers = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: itemsArray}) };

        fetch(`${window.Shopify.routes.root}cart/add.js?sections=${this.cart.getSectionsToRender().map((section) => section.id).join(",")}&sections_url=${window.location.pathname}`, headers)
          .then((response) => response.json())
          .then((response) => {
            this.cart.renderContents(response, false);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
        
        } else{
          const formData = new FormData(this.form);
          // Fly Bundles (quantity breaks) rewrites every /cart/add payload with form_type=product to the main
          // product's selected variant and tier quantity (flyBundlesVolume: handleQuantityBreaksFormSubmit).
          // A quick add on a product page with a Fly offer therefore added the main product instead of the
          // chosen one. The Ajax cart does not need form_type; the hidden input in the form stays untouched.
          if (this.closest('.js-quick-add-content')) formData.delete('form_type');
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;


          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
  
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
  
              const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                }).then(() => {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response, allow_cart_drawer);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
                window.variantAddedQuickModel(response, quickAddModal);
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response, allow_cart_drawer);
                });
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
  
              CartPerformance.measureFromEvent("add:user-action", evt);
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Takes over the state buy-buttons.liquid rendered for the newly selected variant (button from the
      // section-rendering response).
      updateSubmitButton(sourceButton) {
        if (!sourceButton?.dataset.buttonState || !this.submitButton.dataset.buttonState) {
          this.toggleSubmitButton(sourceButton?.hasAttribute('disabled') ?? true, window.variantStrings.soldOut);
          return;
        }
        this.submitButton.dataset.variantId = sourceButton.dataset.variantId ?? '';
        this.submitButton.dataset.variantTitle = sourceButton.dataset.variantTitle ?? '';
        this.setButtonState(sourceButton.dataset.buttonState, sourceButton.hasAttribute('disabled'));
      }

      // state: add | sold-out | unavailable | notify. Only switches between the labels rendered in Liquid,
      // so Weglot's translations stay in place (no text from window.variantStrings).
      setButtonState(state, disabled) {
        const notify = state === 'notify';
        this.submitButton.dataset.buttonState = state;
        this.submitButton.type = notify ? 'button' : 'submit';
        this.submitButton.classList.toggle('js-bis-trigger', notify);
        this.submitButton.toggleAttribute('disabled', disabled);
      }

      toggleSubmitButton(disable = true, text) {
        if (this.submitButton.dataset.buttonState) {
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
          } else {
            this.setButtonState('add', false);
          }
          return;
        }

        // Buttons without rendered labels (product cards) keep the old text handling.
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if(this.submitButtonText.getAttribute('data-custom-text') == 'true'){
            this.submitButtonText.textContent = window.variantStrings.addToCartPDP;
          } else{
            this.submitButtonText.textContent = window.variantStrings.addToCart;            
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
